<template>
	<div>
		<div class="card mb-3">
			<div class="card-body" v-if="!form.patient">
				<div class="label">BUSCAR PACIENTE</div>
				<div class="text-center">
					<!-- <img src="@/assets/img/search-user.png" /> -->
				</div>
				<FormulateInput
					class="mt-3"
					label="Paciente"
					validation-name="Paciente"
					v-model="form.patient"
					type="selectAsync"
					option-value="id"
					option-text="name"
					:options="patients"
					@search="searchPatients"
					@create="patientCreate"
					placeholder="Buscar por C.I. o Nombre"
					createButtonText="Crear paciente nuevo"
					validation="required"
				/>
			</div>
			<div class="card-body" v-if="form.patient">
				<PatientCard :id="form.patient.id" @remove="form.patient = null" />
			</div>
		</div>

		<div class="card mb-3" v-for="(product, index) in form.products" :key="product.id">
			<div class="card-body">
				<div class="btn btn-default btn-remove" @click="productRemove(index)"><i class="fa fa-times"></i></div>
				<ProductCard :product="product.product" :qty="product.qty" :expireAt="product.expireAt" :indications="product.indications" />
			</div>
		</div>

		<div class="card mb-3">
			<div class="card-body">
				<div class="btn btn-block btn-success" @click="$bvModal.show('prescribeMedicineModal')">Agregar medicamento</div>
			</div>
		</div>

		<div class="btn btn-primary btn-block btn-lg" v-if="canCreate" @click="save">
			Preescribir
		</div>

		<PatientModalForm ref="patientModalForm" @upserted="patientCreated" />

		<b-modal id="prescribeMedicineModal" title="Buscar medicamento" no-close-on-backdrop hide-footer>
			<PrescribeMedicineForm @created="productCreated" />
		</b-modal>
	</div>
</template>

<script>
import gql from "graphql-tag"
import PatientModalForm from "@/views/patients/PatientModalForm"
import PatientCard from "@/views/patients/PatientCard"
import PrescribeMedicineForm from "@/views/prescriptions/PrescribeMedicineForm"
import ProductCard from "@/views/products/ProductCard"

export default {
	name: "ClientForm",

	components: {
		PatientModalForm,
		PatientCard,
		PrescribeMedicineForm,
		ProductCard
	},

	data() {
		return {
			loading: true,
			saving: false,
			patients: [],
			section: "selectClient",
			form: {
				patient: null,
				products: []
			}
		}
	},

	computed: {
		canCreate: function() {
			return this.form.patient && this.form.products.length > 0 ? true : false
		}
	},

	async beforeMount() {
		await this.fetchData()
		if (this.$route.params.id) {
			this.action = "update"
			this.title = `Editar médico`
			await this.load()
		}
		this.loading = false
	},
	methods: {
		save() {
			if (!this.saving) {
				this.saving = true

				let dataInput = {
					patient: this.form.patient ? this.form.patient.id : null,
					products: this.form.products
						? this.form.products.map(p => {
								return {
									product: p.product.id,
									productType: p.product.type,
									qty: parseInt(p.qty),
									dose: parseFloat(p.dose),
									doseUnit: p.doseUnit,
									doseType: p.doseType,
									frecuency: p.frecuency ? parseInt(p.frecuency.value) : null,
									frecuencyUnit: p.frecuency ? p.frecuency.option : null,
									duration: p.duration ? parseInt(p.duration.value) : null,
									durationUnit: p.duration ? p.duration.option : null,
									medicalHistory: p.medicalHistory,
									affections: p.affections,
									expireAt: p.expireAt
								}
						  })
						: []
				}
				this.create(dataInput)
			}
		},

		create(data) {
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: PrescriptionInput!) {
							prescriptionCreate(data: $data) {
								id
							}
						}
					`,
					variables: {
						data
					}
				})
				.then(() => {
					this.$toast.success("Prescripción creada correctamente")
					this.$router.push("/prescriptions")
					this.saving = false
				})
				.catch(error => {
					this.parseGQLErrors(error)
					this.saving = false
				})
		},

		load() {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							medic(id: $id) {
								id
								cjp
								name
								lastname
								email
								birthdate
								document {
									type
									number
								}
								phone {
									countryCode
									national
									international
									type
									validated
								}
								address {
									country {
										id
										name
									}
									city
									street
								}
							}
						}
					`,
					variables: { id: this.$route.params.id },
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.form = {
						...this.$omitDeep(data.medic, "__typename")
						// addressCountry: (data.medic.address?.country ) ? data.medic.address.country.id : null,
						// addressCity: (data.medic.address?.city ) ? data.medic.address.city : null,
						// addressStreet: (data.medic.address?.street ) ? data.medic.address.street : null,
					}
				})
				.catch(() => {
					this.$toast.success("El item que desea editar no existe")
					this.$router.go(-1)
				})
		},

		searchPatients(searchText) {
			if (searchText != "") {
				this.$apollo
					.query({
						query: gql`
							query($take: Int, $skip: Int, $search: String) {
								patients(take: $take, skip: $skip, search: $search) {
									data {
										id
										name
										lastname
									}
								}
							}
						`,
						variables: {
							take: 10,
							skip: 0,
							search: searchText
						},
						fetchPolicy: "no-cache"
					})
					.then(({ data }) => {
						this.patients = data.patients.data
						this.loading = false
					})
			}
		},

		patientCreate() {
			console.log("abro modal para crear paciente nuevo.")
			this.$refs.patientModalForm.open()
		},

		patientCreated(patient) {
			this.form.patient = patient
		},

		productCreated(product) {
			this.form.products.push(product)
			this.$bvModal.hide("prescribeMedicineModal")
		},

		productRemove(index) {
			this.form.products.splice(index, 1)
		},

		fetchData() {
			this.loadingCountries = true
			return this.$apollo
				.query({
					query: gql`
						query {
							countries {
								id
								iso
								name
								nativeName
								flag
							}
						}
					`,
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.countries = data.countries
					this.loadingCountries = false
				})
				.catch(err => {
					console.log(err)
				})
		}
	}
}
</script>

<style scoped>
.card-body {
	position: relative;
}
.card-body .btn-remove {
	position: absolute;
	top: 0px;
	right: 0px;
}
</style>
